import {Incentive} from "../../../components/payroll/incentive/incentive";
import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {IncentiveListContainer} from "./IncentiveListContainer";

const tabList = [
  {
    label: 'Personal Incentive',
    key: 'personal-incentive',
  }, {
    label: 'Monthly Group Incentive',
    key: 'monthly-group-incentive',
  }, {
    label: 'Quarterly Group Incentive',
    key: 'quarterly-group-incentive',
  }, {
    label: 'Company Wide Performance',
    key: 'company-wide-performance',
  },
]
export const IncentiveContainer = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState(tabList[0])
  const type = searchParams.get('type')

  useEffect(() => {
    if (type) {
      const find = tabList.find(i => i.key === type)
      setSelectedTab(find || tabList[0])
    }
  }, [type]);

  const onChangeTab = (tab) => {
    navigate(`/payroll/incentive-setting`)
    setSelectedTab(tab)
  }

  return (
      <div className="flex flex-col h-full">
        <div className="h-1 bg-neutral-10" />

        <div className={"bg-white flex flex-1"}>
          <Incentive list={tabList} selectedTab={selectedTab} onChangeTab={onChangeTab}/>
          <div className={"w-full h-full"}>
            <IncentiveListContainer type={selectedTab?.key}/>
          </div>
        </div>

      </div>
  )
}
